import { useQuery } from '@apollo/client';
import {
  getYachtForCharterContactDataQuery,
  getYachtForSaleContactDataQuery
} from '../../graphql/queries';

const getListingContactData = (entity, itemId) => {
  let query = null;
  let listingType = null;
  if (entity === 'yacht_for_charter') {
    query = getYachtForCharterContactDataQuery();
    listingType = 'charter';
  }
  if (entity === 'yacht_for_sale') {
    query = getYachtForSaleContactDataQuery();
    listingType = 'sale';
  }

  if (query === null) return null;

  const { error, loading, data } = useQuery(query, {
    fetchPolicy: 'no-cache',
    variables: { id: itemId }
  });

  if (error || loading || !data || !data.data) return null;

  return { ...data.data, listingType };
};

export default getListingContactData;
